export const M1_UNIT_15 = {
  id: "u15-free-time",
  title: "Unidad 15: Free Time",
  topic: "Hobbies, Sports & Leisure",
  iconType: "game",
  grammarImage: "/u15-free-time.jpg",
  grammarText: "Play (ball games), Go (-ing activities), Do (exercises). Example: Play soccer, Go swimming, Do yoga.",
  sets: [
    // ----------------------------------------------------------------------
    // SET 1: SPORTS (Play vs Go vs Do)
    // Enfoque: Clasificación lógica.
    // ----------------------------------------------------------------------
    {
      id: "u15-set1",
      title: "Set 1: Sports Rules",
      questions: [
        {
          type: "match",
          q: "Match Verb to Sport",
          pairs: [
            { left: "Play", right: "Soccer" },
            { left: "Go", right: "Swimming" },
            { left: "Do", right: "Karate" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ basketball on Fridays.", options: ["play", "go", "do"], a: "play" },
        { type: "mc", q: "She ___ running every morning.", options: ["goes", "plays", "does"], a: "goes" },
        { type: "input", q: "We ___ (hacer) yoga in the park.", a: "do" },
        { type: "input", q: "They ___ (jugar) tennis together.", a: "play" },
        { type: "order", q: "Ordena", words: ["I", "go", "cycling", "on", "Sundays."], a: "I go cycling on Sundays." },
        { type: "match",
          q: "Classify",
          pairs: [
            { left: "Team Sport", right: "Volleyball" },
            { left: "Water Sport", right: "Surfing" },
            { left: "Martial Art", right: "Judo" }
          ],
          a: "completed"
        },
        { type: "mc", q: "He ___ skiing in winter.", options: ["goes", "plays", "does"], a: "goes" },
        { type: "input", q: "Do you ___ (hacer) gymnastics?", a: "do" },
        { type: "order", q: "Ordena", words: ["Let's", "play", "football."], a: "Let's play football." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 2: RELAXING (Hobbies en casa)
    // Enfoque: Verbos de ocio.
    // ----------------------------------------------------------------------
    {
      id: "u15-set2",
      title: "Set 2: Relaxing at Home",
      questions: [
        {
          type: "match",
          q: "Match Action to Object",
          pairs: [
            { left: "Watch", right: "TV" },
            { left: "Read", right: "A book" },
            { left: "Listen to", right: "Music" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I usually ___ a book before bed.", options: ["read", "watch", "see"], a: "read" },
        { type: "mc", q: "She ___ to music on the bus.", options: ["listens", "hears", "watches"], a: "listens" },
        { type: "input", q: "We ___ (ver) movies on Netflix.", a: "watch" },
        { type: "input", q: "He likes to ___ (cocinar) dinner.", a: "cook" },
        { type: "order", q: "Ordena", words: ["I", "listen", "to", "podcasts."], a: "I listen to podcasts." },
        { type: "match",
          q: "Match Hobby",
          pairs: [
            { left: "Garden", right: "Gardening" },
            { left: "Paint", right: "Painting" },
            { left: "Cook", right: "Cooking" }
          ],
          a: "completed"
        },
        { type: "mc", q: "They ___ video games all day.", options: ["play", "go", "do"], a: "play" },
        { type: "input", q: "My hobby is ___ (leer).", a: "reading" },
        { type: "order", q: "Ordena", words: ["She", "loves", "watching", "TV."], a: "She loves watching TV." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 3: GOING OUT (Socializing)
    // Enfoque: Actividades sociales.
    // ----------------------------------------------------------------------
    {
      id: "u15-set3",
      title: "Set 3: Going Out",
      questions: [
        {
          type: "match",
          q: "Match Activity to Place",
          pairs: [
            { left: "See a movie", right: "Cinema" },
            { left: "Eat dinner", right: "Restaurant" },
            { left: "Drink coffee", right: "Café" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ my friends on Saturday.", options: ["meet", "see", "watch"], a: "meet" },
        { type: "mc", q: "We ___ shopping at the mall.", options: ["go", "play", "do"], a: "go" },
        { type: "input", q: "Let's go to the ___ (parque).", a: "park" },
        { type: "input", q: "They ___ (visitar) their grandparents.", a: "visit" },
        { type: "order", q: "Ordena", words: ["We", "go", "out", "on", "Fridays."], a: "We go out on Fridays." },
        { type: "match",
          q: "Social Verbs",
          pairs: [
            { left: "Meet", right: "Friends" },
            { left: "Visit", right: "Family" },
            { left: "Go to", right: "A party" }
          ],
          a: "completed"
        },
        { type: "mc", q: "She loves ___ out in restaurants.", options: ["eating", "cooking", "doing"], a: "eating" },
        { type: "input", q: "I ___ (ir) to the gym.", a: "go" },
        { type: "order", q: "Ordena", words: ["Do", "you", "like", "parties?"], a: "Do you like parties?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 4: READING 1 - "LUCAS'S HOBBIES" (Sports)
    // Enfoque: Comprensión de texto sobre deportes.
    // ----------------------------------------------------------------------
    {
      id: "u15-set4",
      title: "Set 4: Lucas's Hobbies",
      questions: [
        {
          type: "mc",
          q: "READING PART 1:\n'Hi, I'm Lucas. I love sports. I play soccer with my friends on Tuesdays and Thursdays.'\n\nQuestion: What does Lucas play?",
          options: ["Soccer", "Tennis", "Basketball"],
          a: "Soccer"
        },
        {
          type: "blank",
          q: "READING PART 2:\n'On weekends, I go swimming at the local pool. I love the water!'\n\nQuestion: He goes ___ on weekends.",
          a: "swimming"
        },
        {
          type: "match",
          q: "Match Lucas's Schedule",
          pairs: [
            { left: "Tuesday", right: "Soccer" },
            { left: "Weekend", right: "Swimming" },
            { left: "Thursday", right: "Soccer" }
          ],
          a: "completed"
        },
        { type: "input", q: "Lucas loves ___ (deportes).", a: "sports" },
        { type: "order", q: "Ordena", words: ["He", "plays", "with", "his", "friends."], a: "He plays with his friends." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 5: READING 2 - "MARIA'S RELAX DAY" (Home)
    // Enfoque: Rutina tranquila.
    // ----------------------------------------------------------------------
    {
      id: "u15-set5",
      title: "Set 5: Maria's Day Off",
      questions: [
        {
          type: "mc",
          q: "READING PART 1:\n'Maria likes to relax on Sundays. She usually reads a book in the garden.'\n\nQuestion: Where does she read?",
          options: ["In the garden", "In the bedroom", "At the park"],
          a: "In the garden"
        },
        {
          type: "blank",
          q: "READING PART 2:\n'In the afternoon, she listens to music and drinks tea.'\n\nQuestion: She listens to ___.",
          a: "music"
        },
        {
          type: "match",
          q: "Maria's Activities",
          pairs: [
            { left: "Morning", right: "Read book" },
            { left: "Afternoon", right: "Listen to music" },
            { left: "Drink", right: "Tea" }
          ],
          a: "completed"
        },
        { type: "input", q: "She likes to ___ (relajarse).", a: "relax" },
        { type: "order", q: "Ordena", words: ["She", "reads", "in", "the", "garden."], a: "She reads in the garden." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 6: FREQUENCY ADVERBS REVISITED
    // Enfoque: Always/Usually/Never con hobbies.
    // ----------------------------------------------------------------------
    {
      id: "u15-set6",
      title: "Set 6: How often?",
      questions: [
        {
          type: "match",
          q: "Match Frequency",
          pairs: [
            { left: "100%", right: "Always" },
            { left: "50%", right: "Sometimes" },
            { left: "0%", right: "Never" }
          ],
          a: "completed"
        },
        { type: "mc", q: "I ___ go to the gym. (Every day)", options: ["always", "never", "rarely"], a: "always" },
        { type: "mc", q: "She ___ eats meat. (Vegetarian)", options: ["never", "always", "usually"], a: "never" },
        { type: "input", q: "We ___ (a veces) play cards.", a: "sometimes" },
        { type: "input", q: "He ___ (usualmente) watches TV at night.", a: "usually" },
        { type: "order", q: "Ordena", words: ["I", "never", "play", "golf."], a: "I never play golf." },
        { type: "match",
          q: "Logic Check",
          pairs: [
            { left: "I love football", right: "I always play" },
            { left: "I hate swimming", right: "I never go" },
            { left: "I like movies", right: "I often watch" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Do you often go out?", options: ["Yes, I do", "Yes, I am", "Yes, I go"], a: "Yes, I do" },
        { type: "input", q: "They ___ (rara vez) visit us.", a: "rarely" },
        { type: "order", q: "Ordena", words: ["She", "always", "reads", "books."], a: "She always reads books." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 7: MAKING PLANS (Dialogue)
    // Enfoque: Invitar a alguien.
    // ----------------------------------------------------------------------
    {
      id: "u15-set7",
      title: "Set 7: Let's make plans",
      questions: [
        { type: "order", q: "Pregunta", words: ["Do", "you", "want", "to", "go", "to", "the", "cinema?"], a: "Do you want to go to the cinema?" },
        { type: "mc", q: "Reply: 'Yes, that sounds ___.'", options: ["great", "bad", "tired"], a: "great" },
        { type: "input", q: "Are you free on ___ (sábado)?", a: "Saturday" },
        { type: "match",
          q: "Match Invite to Activity",
          pairs: [
            { left: "Let's watch a movie", right: "Cinema" },
            { left: "Let's play ball", right: "Park" },
            { left: "Let's eat", right: "Restaurant" }
          ],
          a: "completed"
        },
        { type: "mc", q: "Sorry, I'm ___.", options: ["busy", "free", "happy"], a: "busy" },
        { type: "input", q: "What about ___ (domingo)?", a: "Sunday" },
        { type: "order", q: "Respuesta", words: ["I", "can't,", "I", "have", "to", "work."], a: "I can't, I have to work." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 8: MIXED PRACTICE
    // Enfoque: Repaso de todo.
    // ----------------------------------------------------------------------
    {
      id: "u15-set8",
      title: "Set 8: Review",
      questions: [
        { type: "mc", q: "I ___ yoga every morning.", options: ["do", "play", "go"], a: "do" },
        { type: "input", q: "She ___ (va) shopping on Saturdays.", a: "goes" },
        { type: "match",
          q: "Complete the phrase",
          pairs: [
            { left: "Play", right: "The guitar" },
            { left: "Listen to", right: "The radio" },
            { left: "Watch", right: "A match" }
          ],
          a: "completed"
        },
        { type: "order", q: "Ordena", words: ["We", "meet", "friends", "at", "the", "cafe."], a: "We meet friends at the cafe." },
        { type: "mc", q: "He doesn't like sports. He ___ plays.", options: ["never", "always", "often"], a: "never" },
        { type: "input", q: "My hobby is ___ (fotografía).", a: "photography" },
        { type: "order", q: "Ordena", words: ["What", "do", "you", "do", "in", "your", "free", "time?"], a: "What do you do in your free time?" }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 9: WRITING PRACTICE (Fill in)
    // Enfoque: Completar un párrafo.
    // ----------------------------------------------------------------------
    {
      id: "u15-set9",
      title: "Set 9: My Weekend",
      questions: [
        { type: "blank", q: "On Saturdays, I ___ (levantarse) late.", a: "get up" },
        { type: "blank", q: "I ___ (desayunar) with my family.", a: "have breakfast" },
        { type: "mc", q: "Then we go to the ___.", options: ["park", "office", "school"], a: "park" },
        { type: "input", q: "We ___ (jugar) football together.", a: "play" },
        { type: "mc", q: "In the evening, we ___ a movie.", options: ["watch", "look", "see"], a: "watch" },
        { type: "order", q: "Ordena", words: ["It", "is", "a", "relaxing", "day."], a: "It is a relaxing day." }
      ]
    },

    // ----------------------------------------------------------------------
    // SET 10: MASTERY (Challenge)
    // Enfoque: Reto final.
    // ----------------------------------------------------------------------
    {
      id: "u15-set10",
      title: "Set 10: Final Challenge",
      questions: [
        { type: "match",
          q: "Ultimate Hobby Match",
          pairs: [
            { left: "Hiking", right: "Mountains" },
            { left: "Gaming", right: "Computer" },
            { left: "Cooking", right: "Kitchen" },
            { left: "Reading", right: "Library" }
          ],
          a: "completed"
        },
        { type: "input", q: "I go ___ (nadar) in the sea.", a: "swimming" },
        { type: "mc", q: "Which is NOT a sport?", options: ["Reading", "Tennis", "Golf"], a: "Reading" },
        { type: "order", q: "Complex Sentence", words: ["I", "usually", "go", "to", "the", "gym", "after", "work."], a: "I usually go to the gym after work." },
        { type: "input", q: "Do you play a musical ___ (instrumento)?", a: "instrument" },
        { type: "mc", q: "Free time = ___ time.", options: ["Leisure", "Work", "Busy"], a: "Leisure" },
        { type: "order", q: "Final", words: ["Enjoy", "your", "free", "time!"], a: "Enjoy your free time!" }
      ]
    }
  ]
};